import { Component, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Branch} from '../../master-data/master-data.model';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import { NEW_UI_FORM_FIELD_DEFAULTS } from '../../shared/styles/new-ui-form-field';

@Component({
    selector: 'app-branch-edit-dialog',
    templateUrl: './branch-edit-dialog.component.html',
    styleUrls: ['./branch-edit-dialog.component.scss'],
    providers: [NEW_UI_FORM_FIELD_DEFAULTS],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BranchEditDialogComponent implements  OnInit {
  private formBuilder = inject(FormBuilder);
  dialogRef = inject<MatDialogRef<BranchEditDialogComponent>>(MatDialogRef);
  editBranch = inject<Branch>(MAT_DIALOG_DATA);


  public editBranchFormGroup: FormGroup;

  ngOnInit() {
    this.editBranchFormGroup = this.createForm();
  }

  createForm() {
    return this.formBuilder.group({
      uuid: [this.editBranch ? this.editBranch?.uuid : ''],
      name: [
        this.editBranch ? this.editBranch?.name : '',
        Validators.required,
      ],

      externalId: [
        this.editBranch ? this.editBranch?.externalId : '',
      ],
      fullname: [
        this.editBranch ? this.editBranch?.fullname : '',
      ],
      address: [
        this.editBranch ? this.editBranch?.address : '',
      ],
      city: [
        this.editBranch ? this.editBranch?.city : '',
      ],
      postal: [this.editBranch ? this.editBranch?.postal : ''],

      contact: [
        this.editBranch ? this.editBranch?.contact : '',
      ],
      email: [
        this.editBranch ? this.editBranch?.email : '',
      ],
      phone: [
        this.editBranch ? this.editBranch?.phone : '',
      ],
      areas: [
        this.editBranch ? this.editBranch?.areas : '',
      ],
    });

  }
  onCloseClick(): void {
    this.dialogRef.close();
  }

  onSave() {
    this.dialogRef.close(this.editBranchFormGroup.value);
  }
}
